import httpClient from './httpClient';

const prefix = 'security'

export default {
    async getSecurityAll () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getSecurityAll`)
        return dataSecurity
    },
    async getSecurityByCompany () {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getSecurityByCompany`)
        return data
    },
    async getSecurityByCompanyAndId (id) {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getSecurityByCompanyAndId/${id}`)
        return data
    },

    async getFromIdWithRelationById (id) {
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getFromIdWithRelationById?id=${id}`)
        return data
    },

    async createSecurity (body) {
        const { data } = await httpClient({ requiresAuth: true }).post(`${prefix}/createSecurity`, body)
        return data
    },

    async updateSecurityPermissionById (body, id) {
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateSecurityPermissionById/${id}`, body)
        return data
    },

    async updateSecurity (body, id) {
        let payload = {
            data: body.data[0]
        }
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateSecurity/${id}`,payload)
        return data
    },

    async updateSecurityIsActiveById (body, id) {
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateSecurityIsActiveById/${id}`, body)
        return data
    },

    async deleteSecurity (id) {
        const { data } = await httpClient({ requiresAuth: true }).delete(`${prefix}/deleteSecurity/${id}`)
        return data
    }
}